var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutedIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.75,
    height: 20.49,
    viewBox: "0 0 27.75 20.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.75,
    height: 20.49,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.915.4A2.419,2.419,0,0,0,11.888.167a2.371,2.371,0,0,0-1.476.517L5.48,4.635H2.364A2.364,2.364,0,0,0,0,7V13.34A2.365,2.365,0,0,0,2.364,15.7H5.48l4.932,3.943h0a2.345,2.345,0,0,0,1.461.522,2.382,2.382,0,0,0,1.026-.232,2.347,2.347,0,0,0,1.35-2.13V2.53A2.356,2.356,0,0,0,12.915.4M11.341,16.663,6.9,13.115a1.446,1.446,0,0,0-.909-.318H2.913V7.538H5.994A1.434,1.434,0,0,0,6.9,7.223l4.438-3.547Z",
    transform: "translate(0 0.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.626.444,16.589.408A1.455,1.455,0,1,0,14.568,2.5a10.966,10.966,0,0,1,0,15.5,1.454,1.454,0,0,0,1.024,2.485h0a1.471,1.471,0,0,0,1.029-.426,13.876,13.876,0,0,0,0-19.62",
    transform: "translate(7.062 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.548,4.512A1.455,1.455,0,1,0,10.49,6.57a2.332,2.332,0,0,1,0,3.289,1.441,1.441,0,0,0-.313,1.584,1.422,1.422,0,0,0,.323.483,1.448,1.448,0,0,0,2.049-.009,5.235,5.235,0,0,0,0-7.4",
    transform: "translate(5.032 2.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.585,2.476a1.455,1.455,0,1,0-2.058,2.056l0,0a6.64,6.64,0,0,1,0,9.391,1.454,1.454,0,0,0,1.029,2.485h0a1.447,1.447,0,0,0,1.024-.427l0,0a9.546,9.546,0,0,0,0-13.5",
    transform: "translate(6.049 1.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 0,
    x2: 0,
    y2: 20,
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedIconImg);
export default __webpack_public_path__ + "static/media/muted-icon-img.1c57262a57116cc8e16f0ab917853587.svg";
export { ForwardRef as ReactComponent };